import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlbums2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="albums-2, cover"><path d="M18.25 3.75H5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 7.75H4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 11.75H20.25L18.7031 20.25H5.29688L3.75 11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlbums2;
